import { nonNullish } from './nullish.util';

/** check deep equal */
export const isEqual = (x: any, y: any) => {
  if (x === y) {
    return true;
  } else if (typeof x === 'object' && nonNullish(x) && typeof y === 'object' && nonNullish(y)) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }

    for (const prop in x) {
      // eslint-disable-next-line no-prototype-builtins
      if (y.hasOwnProperty(prop)) {
        if (!isEqual(x[prop], y[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
};

export function isObjectEmpty<T>(obj: T): boolean {
  return Object.keys(obj).every((k) => !obj[k]);
}

export function compareObjects<T>(obj1: T, obj2: T): Partial<T> {
  const differences: any = {};
  const hasOwnProperty = Object.prototype.hasOwnProperty;
  for (const key in obj1) {
    if (hasOwnProperty.call(obj1, key) && hasOwnProperty.call(obj2, key)) {
      const val1 = obj1[key];
      const val2 = obj2[key];
      if (typeof val1 === 'object' && val1 !== null && typeof val2 === 'object' && val2 !== null) {
        const nestedDifferences = compareObjects(val1, val2);
        if (Object.keys(nestedDifferences).length > 0) {
          differences[key] = nestedDifferences;
        }
      } else if (val1 !== val2) {
        differences[key] = { oldValue: val1, newValue: val2 };
      }
    } else if (hasOwnProperty.call(obj1, key)) {
      differences[key] = { oldValue: obj1[key], newValue: undefined };
    } else if (hasOwnProperty.call(obj2, key)) {
      differences[key] = { oldValue: undefined, newValue: obj2[key] };
    }
  }
  return differences;
}
